
window.addEventListener("DOMContentLoaded", (event) => {
  function slideshowcaption(){
    var logoelement = document.querySelector('.site-logo a'); 
    var rectelement = logoelement.getBoundingClientRect();
   // console.log(rectelement);
    if(document.querySelector("div.slideshow__caption")){
      document.querySelector("div.slideshow__caption").style.transform = "none";
      document.querySelector("div.slideshow__caption").style.left = rectelement.left + "px";  
    }
    
  //  console.log(rectelement.left);
  }
  slideshowcaption();

  function videosection(){
    if(screen.width < 750){
       var screenwithcal = screen.width; 
    console.log(screenwithcal);
    if( document.querySelector(".vintagered .restoreitem")){
       document.querySelector(".vintagered .restoreitem").style.flexBasis = (screenwithcal - 20) + "px";   
    }
   
    }
   
    /* var rectelement = logoelement.getBoundingClientRect();
   
   // console.log(rectelement);
    document.querySelector("div.slideshow__caption").style.transform = "none";
    document.querySelector("div.slideshow__caption").style.left = rectelement.left + "px";*/
  //  console.log(rectelement.left);
  }
  videosection();

  addEventListener("resize", (event) => {});

  onresize = (event) => {
    slideshowcaption();
    videosection();
  };
  console.log("samtjpsj");

  const slider = document.querySelector('.madewithlove');
let mouseDown = false;
let startX, scrollLeft;

let startDragging = function (e) {
  mouseDown = true;
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
};
let stopDragging = function (event) {
  mouseDown = false;
};

slider.addEventListener('mousemove', (e) => {
  e.preventDefault();
  if(!mouseDown) { return; }
  const x = e.pageX - slider.offsetLeft;
  const scroll = x - startX;
  slider.scrollLeft = scrollLeft - scroll;
});


  const slider1 = document.querySelector('.beforeafter');
let mouseDown1 = false;
let startX1, scrollLeft1;

let startDragging1 = function (e) {
  mouseDown1 = true;
  startX1 = e.pageX - slider1.offsetLeft;
  scrollLeft1 = slider1.scrollLeft;
};
let stopDragging1 = function (event) {
  mouseDown1 = false;
};

slider1.addEventListener('mousemove', (e) => {
  
  if(!mouseDown1) { return; }
  e.preventDefault();
  const x = e.pageX - slider1.offsetLeft;
  const scroll = x - startX1;
  slider1.scrollLeft = scrollLeft1 - scroll;
});


// Add the event listeners
slider1.addEventListener('mousedown', startDragging1, false);
slider1.addEventListener('mouseup', stopDragging1, false);
slider1.addEventListener('mouseleave', stopDragging1, false);
  
// Add the event listeners
slider.addEventListener('mousedown', startDragging, false);
slider.addEventListener('mouseup', stopDragging, false);
slider.addEventListener('mouseleave', stopDragging, false);
});





document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll(
    '.yearsold, .comparision .grid'
  );

  sliders.forEach(function (slider) {

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', function (e) {

      // Only allow the left mouse button
      if (e.button !== 0) return;

      isDragging = true;
      startX = e.clientX;
      startScrollLeft = slider.scrollLeft;

      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';

      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {

      if (!isDragging) return;

      const distance = e.clientX - startX;
      slider.scrollLeft = startScrollLeft - distance;

    });

    document.addEventListener('mouseup', function () {

      if (!isDragging) return;

      isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';

    });

    // Stop dragging if the mouse leaves the browser window
    window.addEventListener('blur', function () {
      if (!isDragging) return;

      isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
    });

  });

});